import { render } from "./SingleCommentReply.vue?vue&type=template&id=485c6905&ts=true"
import script from "./SingleCommentReply.vue?vue&type=script&lang=ts"
export * from "./SingleCommentReply.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__